import PageLayout from 'PageLayout';
import { MoveLeft } from 'lucide-react';
import moment from 'moment';

import {
    EButton,
    ECheckbox,
    EDateInput,
    EFormSection,
    EMultiSelect,
    ENumberInput,
    EPageTitle,
    ESelect
} from 'libs/ui';

import useFlightMarkupForm from '../Hooks/useFlightMarkupForm';

export default function FlightMarkupForm() {

    const {
        navigate,
        groupList,
        searchTypeDropdown,
        travelTypeDropdown,
        groupTypes,
        flightAllClassTypes,
        flightCabinClassTypes,
        supplierList,
        airlinesList,
        getAirlinesBySuppliers,
        allCountryList,
        airportByCoutries,
        getAllAirportByCountries,
        airportByDestinationCoutries,
        getAllAirportByDestinationCountries,
        markupFormChargesDropdown,
        flightChargeApplyForDropdown,
        flightApplyTypeDropdown,
        handleChange,
        handleChangeMarkupChargeWithAmountTypes,
        markup,
        handleSaveMarkup
    } = useFlightMarkupForm();

    return (
        <PageLayout
            footer={
                <div className="flex justify-end gap-2 ">
                    <EButton
                        variant="outline"
                        disabled={markup.isLoading}
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </EButton>
                    <EButton
                        loading={markup.isLoading}
                        onClick={handleSaveMarkup}
                    >
                        Save
                    </EButton>
                </div>
            }
        >
            <EPageTitle
                title={`Create Flight Markup B2B`}
                end={
                    <div className="flex justify-end gap-2">
                        <EButton
                            variant='outline'
                            leftSection={<MoveLeft />}
                            disabled={markup.isLoading}
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </EButton>
                    </div>
                }
            />
            <div>
                <EFormSection
                    title={"Service"}
                >
                    <ESelect
                        label="Apply For"
                        placeholder="Select"
                        data={flightChargeApplyForDropdown?.map((each) => ({
                            label: each.key,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightChargeApplyFor === "YES"}
                        error={markup.errors.flightChargeApplyFor}
                        value={markup.details.flightChargeApplyFor}
                        onChange={(value) => handleChange("flightChargeApplyFor", value)}
                    />

                    <EMultiSelect
                        label="Journey Types"
                        placeholder="Select"
                        data={travelTypeDropdown?.map((each) => ({
                            label: each.key,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightTypes === "YES"}
                        error={markup.errors.flightTypes}
                        value={markup.details.flightTypes}
                        onChange={(value) => handleChange("flightTypes", value)}
                    />

                    {/* <ESelect
                        label="Apply On"
                        placeholder="Select"
                        data={flightApplyTypeDropdown?.map((each) => ({
                            label: each.key,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.applyOn === "YES"}
                        error={markup.errors.applyOn}
                        value={markup.details.applyOn}
                        onChange={(value) => handleChange("applyOn", value)}
                    /> */}

                    <EMultiSelect
                        label="Search Type"
                        placeholder="Select"
                        data={searchTypeDropdown?.map((each) => ({
                            label: each.key,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightSearchTypes === "YES"}
                        error={markup.errors.flightSearchTypes}
                        value={markup.details.flightSearchTypes}
                        onChange={(value) => handleChange("flightSearchTypes", value)}
                    />

                    <EMultiSelect
                        label="Apply Type"
                        placeholder="Select"
                        data={flightApplyTypeDropdown?.map((each) => ({
                            label: each.key,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightMarkupApplyType === "YES"}
                        error={markup.errors.flightMarkupApplyType}
                        value={markup.details.flightMarkupApplyType}
                        onChange={(value) => handleChange("flightMarkupApplyType", value)}
                    />

                    <EMultiSelect
                        label="Affiliate Group"
                        placeholder="Select"
                        data={groupList?.map((each) => ({
                            label: each.name,
                            value: String(each.id)
                        })) || []}
                        required={markup.rules.affiliateGroupIds === "YES"}
                        error={markup.errors.affiliateGroupIds}
                        value={markup.details.affiliateGroupIds.map(String)}
                        onChange={(value) => handleChange("affiliateGroupIds", value)}
                    />
                </EFormSection>

                <EFormSection
                    title="Markup Validity (Travel Date)"
                >
                    <EDateInput
                        label="Start Date"
                        placeholder="Select a date"
                        minDate={new Date()}
                        required={markup.rules.startDate === "YES"}
                        error={markup.errors.startDate}
                        value={markup.details.startDate ? new Date(markup.details.startDate) : null}
                        onChange={(value) => handleChange("startDate", value ? moment(value).format("YYYY-MM-DD") : null)}
                    />

                    <EDateInput
                        label="End Date"
                        placeholder="Select a date"
                        disabled={markup.details.startDate === ""}
                        minDate={markup.details.startDate ? new Date(markup.details.startDate) : undefined}
                        required={markup.rules.endDate === "YES"}
                        error={markup.errors.endDate}
                        value={markup.details.endDate ? new Date(markup.details.endDate) : null}
                        onChange={(value) => handleChange("endDate", value ? moment(value).format("YYYY-MM-DD") : null)}
                    />
                </EFormSection>

                <EFormSection
                    title="Gross Price Range"
                >
                    <ENumberInput
                        label="From Price"
                        placeholder="Enter price"
                        required={markup.rules.minimumGrossPrice === "YES"}
                        error={markup.errors.minimumGrossPrice}
                        value={markup.details.minimumGrossPrice ?? undefined}
                        onChange={(value) => handleChange("minimumGrossPrice", value || null)}
                    />

                    <ENumberInput
                        label="To Price"
                        placeholder="Enter price"
                        required={markup.rules.maximumGrossPrice === "YES"}
                        error={markup.errors.maximumGrossPrice}
                        value={markup.details.maximumGrossPrice ?? undefined}
                        onChange={(value) => handleChange("maximumGrossPrice", value || null)}
                    />
                </EFormSection>

                <EFormSection
                    title="Country Wise"
                >
                    <EMultiSelect
                        label="Origin Country"
                        placeholder="Select"
                        data={allCountryList || []}
                        required={markup.rules.flightOriginCountryIds === "YES"}
                        error={markup.errors.flightOriginCountryIds}
                        value={markup.details.flightOriginCountryIds.map(String)}
                        onChange={(value) => {
                            getAllAirportByCountries(value);
                            handleChange("flightOriginCountryIds", value);
                        }}
                    />

                    <EMultiSelect
                        label="Destination Country"
                        placeholder="Select"
                        data={allCountryList || []}
                        required={markup.rules.flightDestinationCountryIds === "YES"}
                        error={markup.errors.flightDestinationCountryIds}
                        value={markup.details.flightDestinationCountryIds.map(String)}
                        onChange={(value) => {
                            getAllAirportByDestinationCountries(value);
                            handleChange("flightDestinationCountryIds", value);
                        }}
                    />
                </EFormSection>

                <EFormSection
                    title="Route Wise"
                >
                    <EMultiSelect
                        label="Origin Airport"
                        placeholder="Select"
                        data={airportByCoutries}
                        required={markup.rules.originAirportIds === "YES"}
                        error={markup.errors.originAirportIds}
                        value={markup.details.originAirportIds.map((item) => String(item))}
                        onChange={(value) => handleChange("originAirportIds", value)}
                    />
                    <EMultiSelect
                        label="Destination Airport"
                        placeholder="Select"
                        data={airportByDestinationCoutries}
                        required={markup.rules.destinationAirportIds === "YES"}
                        error={markup.errors.destinationAirportIds}
                        value={markup.details.destinationAirportIds.map((item) => String(item))}
                        onChange={(value) => handleChange("destinationAirportIds", value)}
                    />
                </EFormSection>

                <EFormSection
                    title="Flight Class"
                >
                    <EMultiSelect
                        label="Flight Class"
                        placeholder="Select"
                        data={flightAllClassTypes?.map((each) => ({
                            label: each.label,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightClass === "YES"}
                        error={markup.errors.flightClass}
                        value={markup.details.flightClass}
                        onChange={(value) => handleChange("flightClass", value)}
                    />

                    <EMultiSelect
                        label="Flight Cabin Class"
                        placeholder="Select"
                        data={flightCabinClassTypes?.map((each) => ({
                            label: each.label,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightCabin === "YES"}
                        error={markup.errors.flightCabin}
                        value={markup.details.flightCabin}
                        onChange={(value) => handleChange("flightCabin", value)}
                    />
                </EFormSection>

                <EFormSection
                    title="Suppliers / Airlines"
                >
                    <EMultiSelect
                        label="Suppliers"
                        placeholder="Select"
                        data={supplierList?.map((each) => ({
                            label: each.label,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightTicketSupplierIds === "YES"}
                        error={markup.errors.flightTicketSupplierIds}
                        value={markup.details.flightTicketSupplierIds.map(String)}
                        onChange={(value) => {
                            getAirlinesBySuppliers(value);
                            handleChange("flightTicketSupplierIds", value);
                        }}
                    />

                    <EMultiSelect
                        label="Airlines"
                        placeholder="Select"
                        data={airlinesList?.map((each) => ({
                            label: each.label,
                            value: String(each.value)
                        })) || []}
                        required={markup.rules.flightAirlineIds === "YES"}
                        error={markup.errors.flightAirlineIds}
                        value={markup.details.flightAirlineIds.map(String)}
                        onChange={(value) => handleChange("flightAirlineIds", value)}
                    />
                </EFormSection>

                <EFormSection
                    fullWidth
                    title="Markup"
                >
                    <div className="flex flex-col gap-5">
                        {markupFormChargesDropdown?.map((each, index) => (
                            <div key={index + "_markup"} className="flex gap-6">
                                <ENumberInput
                                    min={0}
                                    label={each.key}
                                    placeholder="Enter price"
                                    // value={markup.details.markupChargeWithAmountTypes?.[index]?.amount}
                                    // onChange={(value) => handleChangeMarkupChargeWithAmountTypes(index, "amount", value)}
                                    value={
                                            markup.details.markupChargeWithAmountTypes?.find(
                                            val => val.markupFormCharge === each.value
                                            )?.amount
                                        }
                                    onChange={(value) =>{
                                            const selectedIndex=markup.details.markupChargeWithAmountTypes?.findIndex(val=>val.markupFormCharge === each.value)
                                            handleChangeMarkupChargeWithAmountTypes(selectedIndex, "amount", value)
                                        }}
                                />
                                <ESelect
                                    label="Fee Type"
                                    placeholder="Select"
                                    data={["FIXED", "PERCENTAGE"]}
                                    // value={markup.details.markupChargeWithAmountTypes?.[index]?.feeType}
                                    // onChange={(value) => handleChangeMarkupChargeWithAmountTypes(index, "feeType", value)}
                                    value={
                                            markup.details.markupChargeWithAmountTypes?.find(
                                            val => val.markupFormCharge === each.value
                                            )?.feeType
                                        }
                                    onChange={(value) =>{
                                            const selectedIndex=markup.details.markupChargeWithAmountTypes?.findIndex(val=>val.markupFormCharge === each.value)
                                            handleChangeMarkupChargeWithAmountTypes(selectedIndex, "feeType", value)
                                        }}    
                                />
                                <div></div>
                            </div>
                        ))}

                        <ECheckbox
                            label="Exclusive GST?"
                            checked={markup.details.gst}
                            onChange={(e) => handleChange("gst", e.target.checked)}
                        />
                    </div>
                </EFormSection>
            </div>
        </PageLayout>
    );
}
